import { toast } from "react-toastify";
import React from "react";
import OrderTotal from "../Components/OrderTotal";

const availableTypes = [
  "info",
  "success",
  "warning",
  "error",
  "dark",
  "default",
];

function Notify({ onClick, actionText, message, dismiss, className, id }) {
  return (
    <>
      <span
        className={`messages__text${
          actionText || dismiss ? " messages__text--with-actions" : ""
        }`}
      >
        {message}
      </span>
      {actionText && (
        <button className="messages__action" onClick={onClick}>
          {actionText}
        </button>
      )}
      {dismiss && (
        <button className="messages__dismiss" onClick={dismiss}></button>
      )}
    </>
  );
}

export default function useToast({
  type, // info | success | warning | error | defult | dark
  id,
  action,
  actionText,
  message,
  dismissable,
}) {
  if (!availableTypes.includes(type)) {
    throw new Error("The toast type must be one of the `availableTypes`");
  }
  if (!id) {
    throw new Error("You need to provide an id for the toast");
  }
  // Do not do this at home (AKA: use components inside hooks)
  const notify = () =>
    toast[type](
      <Notify
        onClick={async () => {
          if (action) {
            const p = action().then((res) => {
              console.debug("RESP", res);
              if (res) {
                toast.dismiss(id);
              }
            });
          }
        }}
        id={id}
        dismiss={dismissable ? () => toast.dismiss(id) : false}
        actionText={action && actionText} // only pass actionText if we got an action
        message={message}
      ></Notify>,
      { toastId: id }
    );

  return notify;
}
